import { render, staticRenderFns } from "./RecoveryAccount.vue?vue&type=template&id=7f5cd07a&"
import script from "./RecoveryAccount.vue?vue&type=script&lang=js&"
export * from "./RecoveryAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports